// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module__header___13JxC","body":"style-module__body___18muw"};